/** 与后端 FeedbackService 限流策略对齐 */
export const FEEDBACK_CONTENT_MIN = 5;
export const FEEDBACK_CONTENT_MAX = 2000;
export const FEEDBACK_CONTACT_MAX = 200;
/** 前端冷却（秒），略短于后端 30s 间隔 */
export const FEEDBACK_CLIENT_COOLDOWN_SEC = 30;

const STORAGE_KEY = 'aivideoclip_feedback_last_submit';

export function getFeedbackCooldownRemainingSec() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return 0;
    const last = Number(raw);
    if (!Number.isFinite(last)) return 0;
    const elapsed = Math.floor((Date.now() - last) / 1000);
    return Math.max(0, FEEDBACK_CLIENT_COOLDOWN_SEC - elapsed);
  } catch (e) {
    return 0;
  }
}

export function markFeedbackSubmitted() {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch (e) {
    // ignore
  }
}
